import React from "react";

const EpicScreen = () => {
  return <div> EpicScreen</div>;
};

export default EpicScreen;
